import React, { type FC, memo, type PropsWithChildren } from 'react';
import clsx from 'clsx';
import { Text } from '@is24at/react-ui-core';
import {
  Notification as CoreNotification,
  NotificationType,
} from '@is24at/react-notifications';
import { FormSubmitStatus } from 'routes/Expose/modules/form';
import styles from './Notification.scss';

type Props = {
  formSubmitted: boolean;
  formSubmitStatus: FormSubmitStatus;
};

const RenderOnce = memo<React.PropsWithChildren>(
  // eslint-disable-next-line react/jsx-no-useless-fragment
  ({ children }) => <>{children}</>,
  () => true,
);

const Notification: FC<Props> = ({ formSubmitted, formSubmitStatus }) => (
  <>
    {formSubmitted && formSubmitStatus === FormSubmitStatus.SUCCESS ? (
      <section className={clsx(styles.container, 'mt-16 mb-16 w-full')}>
        <CoreNotification type={NotificationType.SUCCESS}>
          {({ Body, Title }) => {
            const TitleWithClassName = Title as typeof Title &
              FC<PropsWithChildren<{ className?: string }>>;

            return (
              <RenderOnce>
                <Body>
                  <TitleWithClassName
                    className={clsx(styles['lh-22'], styles.title)}
                  >
                    <Text tag="span" size="m" bold>
                      Anfrage gesendet
                    </Text>
                  </TitleWithClassName>
                  <div>
                    <Text tag="p" className={styles['lh-22']}>
                      Wir wünschen dir viel Erfolg!
                    </Text>
                  </div>
                </Body>
              </RenderOnce>
            );
          }}
        </CoreNotification>
      </section>
    ) : null}
    {formSubmitted && formSubmitStatus === FormSubmitStatus.FAILURE ? (
      <section className={clsx(styles.container, 'mt-16 mb-16 w-full')}>
        <CoreNotification type={NotificationType.ERROR}>
          {({ Body, Title }) => {
            const TitleWithClassName = Title as typeof Title &
              FC<PropsWithChildren<{ className?: string }>>;

            return (
              <RenderOnce>
                <Body>
                  <TitleWithClassName
                    className={clsx(styles['lh-22'], styles.title)}
                  >
                    <Text tag="span" size="m" bold>
                      Anfrage konnte nicht gesendet werden
                    </Text>
                  </TitleWithClassName>
                  <div>
                    <Text tag="p" className={styles['lh-22']}>
                      Bitte versuche es erneut oder kontaktiere den Anbieter
                      telefonisch.
                    </Text>
                  </div>
                </Body>
              </RenderOnce>
            );
          }}
        </CoreNotification>
      </section>
    ) : null}
  </>
);

export default Notification;
